import { t } from "../tokens-D9z8Q6nJ.js";
const e = {
  styleOverrides: {
    root: {
      fontWeight: t
    }
  }
};
export {
  e as default
};
